'use strict';

class PatientsService {

  constructor ($http, $q, $rootScope) {
    this.$http = $http;
    this.$q = $q;
    this.$rootScope = $rootScope;
  }

  save(data){
    return this.$http.post('/api/patients/register', data);
  }

  getPatientData(pids, sortKey, page, searchKey, pageSize){
    return this.$http.post('/api/patients/getPatientData', {sort: sortKey, pids: pids, page: page, search: searchKey, pageSize: pageSize});
  }

  static matchRecords(mdat, idat){
    var patients = [];

    idat.forEach(function(record){
      mdat.forEach(function(patient){
        if (patient.pid === record.ids[0].idString){
          patient.vorname = record.fields.vorname;
          patient.nachname = record.fields.nachname;
          patient.geburtsname = record.fields.geburtsname;
          patient.ort = record.fields.ort;
          patient.plz = record.fields.plz;
          patient.birthdate = new Date(record.fields.geburtsjahr + "/" + record.fields.geburtsmonat + "/" + record.fields.geburtstag);

          patients.push(patient);
        }
      });
    });
    return patients;
  }

  getAll(sortKey, page, searchKey){
    var defer = this.$q.defer();
    var currentPage = page || 0;

    var self = this;
    this.$http.get('/api/patients/search/findAllowedPatients', {params: {sort: 'lastModifiedAt,desc'}}).then(
      function (data) {
        var patients = data.data;

        if (self.$rootScope.user.hasPermission("00111")){
          var pids = data.data.map(function(patient){ return patient.pid; });
          self.getPatientData(pids, sortKey, currentPage, searchKey).then(function(data){
            defer.resolve({ patients: PatientsService.matchRecords(patients, data.data.pageList), totalPages: data.data.pageCount });
          }, function(){
            defer.reject();
          });
        } else {
          defer.resolve({ patients: patients });
        }
      }, function(){
        defer.reject();
      });

    return defer.promise;
  }

  updateIdat(data){
    return this.$http.post('/api/patients/' + data.pid + '/idat', data);
  }

  updateMdat(data){
    return this.$http.post('/api/patients/' + data.pid + '/mdat', data);
  }

  remove(item){
    return this.$http.delete('/api/patients/' + item.pid);
  }

  findByPid(pid){
    var defer = this.$q.defer();

    var self = this;
    this.$http.get('/api/patients/search/findAllowedPatientsByPid/' + pid).then(function(data){
      var patients = data.data;

      if (patients.length !== 1){
        defer.reject();
      } else {
        if (self.$rootScope.user.hasPermission("00111")) {
          var pids = data.data.map(function (patient) {
            return patient.pid;
          });
          self.getPatientData(pids).then(function (data) {
            var matchedPatients = PatientsService.matchRecords(patients, data.data.pageList);
            defer.resolve(matchedPatients[0]);
          }, function () {
            defer.reject();
          });
        } else {
          defer.resolve(patients[0]);
        }
      }
    }, function(){
      defer.reject();
    });

    return defer.promise;
  }

  addTargetLesion(pid, targetLesion){
    return this.$http.post('/api/patients/' + pid + '/targetLesions', targetLesion);
  }

  deleteTargetLesion(pid, uuid){
    return this.$http.delete('/api/patients/' + pid + '/targetLesions/' + uuid);
  }

  addTreatment(pid){
    return this.$http.post('/api/patients/' + pid + '/treatments', {});
  }

  updateTreatment(treatment){
    return this.$http.put('/api/treatments/' + treatment.uuid, treatment);
  }

  requestTreatmentForm(uuid, model){
    return this.$http.post('/api/treatments/' + uuid + '/actions', model);
  }

  getTreatmentForm(treatmentUuid, actionUuid){
    return this.$http.get('/api/treatments/' + treatmentUuid + '/actions/' + actionUuid);
  }

  saveTreatmentForm(treatment, action, model, customModel){
    return this.$http.put('/api/treatments/' + treatment.uuid + '/actions/' + action.uuid,
      {
        data: JSON.stringify(model),
        customData: JSON.stringify(customModel)
      });
  }

  getTreatmentReport(uuid){
    return this.$http.get('/api/treatments/' + uuid + '/report', { responseType: 'arraybuffer' });
  }

  getInterventionProtocol(uuid, actionUuid){
    return this.$http.get('/api/treatments/' + uuid + '/actions/' + actionUuid + '/report', { responseType: 'arraybuffer' });
  }

  findRecent(){
    var defer = this.$q.defer();

    var self = this;
    this.$http.get('/api/patients/search/findAllowedRecentPatients').then(
      function (data) {
        var patients = data.data;

        if (self.$rootScope.user.hasPermission("00110")){
          var pids = data.data.map(function(patient){ return patient.pid; });
          self.getPatientData(pids).then(function(data){
            defer.resolve(PatientsService.matchRecords(patients, data.data.pageList));
          }, function(){
            defer.reject();
          });
        } else {
          defer.resolve(patients);
        }
      }, function(){
        defer.reject();
      });

    return defer.promise;
  }

  findTreatmentActionsByTargetLesion(pid, i){
    return this.$http.get('/api/patients/' + pid + '/findTreatmentActionsByTargetLesion/' + i);
  }

  addTreatmentDeletionRequest(params){
    return this.$http.put('/api/treatments/' + params.uuid + '/deletionrequest', params);
  }

  addTreatmentActionDeletionRequest(params){
    return this.$http.put(`/api/treatments/${params.treatUuid}/actions/${params.actionUuid}/deletionrequest`, params);
  }

  addPatientDeletionRequest(params){
    return this.$http.put('/api/patients/' + params.pid + '/deletionrequest', params);
  }

  removeTreatmentAction(treatmentUuid, actionUuid){
    return this.$http.delete(`/api/treatments/${treatmentUuid}/actions/${actionUuid}`);
  }
}

PatientsService.$inject = ['$http', '$q', '$rootScope'];
export default PatientsService;



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/services/patientsservice.js